import React from "react";
import { TextField } from "@mui/material";
import "./TextFieldComponent.css";
import PropTypes from "prop-types";

const TextFieldComponent = ({label, changeHandler , value, type, InputProps, placeholder, error, helperText, required}) => {
  return (
    <div className="box">
      <label className="left"> {`${label} : ${required ? "*" : ""}` } </label>
      <TextField
        error={error}
        className="right"
        variant="outlined"
        onChange={(event) => changeHandler(event.target.value)}
        value={value}
        autoComplete="false"
        type={type}
        InputProps={InputProps}
        placeholder={placeholder || label}
        helperText={error && helperText}
      />
    </div>
  );
};

TextFieldComponent.propTypes = {
  label: PropTypes.string,
  changeHandler: PropTypes.func,
  value: PropTypes.string,
  type: PropTypes.string,
  InputProps: PropTypes.object,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  required: PropTypes.bool
};

TextFieldComponent.defaultProps = {
  label: "",
  changeHandler: null,
  value: "",
  type: "text",
  InputProps: {},
  placeholder: "",
  error: false,
  helperText: "",
  required: false
};

export default TextFieldComponent;
